import PriceRangeTapEvent from 'lib/Tracking/Srp/SearchFilters/PriceRangeTap';
import { usePriceFilter } from 'lib/hooks/useSrpFilters';
import useEvents from 'lib/hooks/useEvents';

import InputSliderBlock, {
  InputSliderBlockValue,
} from 'components/Shared/SearchFilter/InputSliderBlock';

export default function PriceInputSliderBlock(): JSX.Element {
  const logger = useEvents();
  const { value, setValue } = usePriceFilter();

  const onChange = (val: InputSliderBlockValue): void => {
    setValue({ ...value, ...val });
    logger.log(PriceRangeTapEvent());
  };

  return (
    <InputSliderBlock
      onChange={onChange}
      minAllowed={0}
      maxAllowed={100000}
      initialMin={value.min}
      initialMax={value.max}
      minPlaceholder={'$0'}
      maxPlaceholder={'$100,000+'}
      pushable={false}
      step={500}
      hasThousandSeparator={true}
      getMinPrefix={(): string => '$'}
      getMaxPrefix={(): string => '$'}
      getMaxSuffix={({ numericValue }): string | undefined =>
        numericValue && numericValue >= 100000 ? '+' : undefined
      }
    />
  );
}
